import axiosInstance from '@/store/axios';
import { rejectError, rejectErrorApiV2 } from '@/store/helper';

export default {
  namespaced: true,
  state: {
    fileTranscodingMinutes: 0,
  },
  getters: {
    getFileTranscodingMinutes(state) {
      return state.fileTranscodingMinutes;
    },
  },
  mutations: {
    setFileTranscodingMinutes(state, quantity) {
      state.fileTranscodingMinutes = quantity;
    },
  },
  actions: {
    getUsage({ commit }) {
      const data = {
        query: {
          aggregate: true,
        },
      };
      return axiosInstance.post('/api/2/resource-usage-reports', data)
        .then((result) => {
          if (result.data.error) {
            return rejectErrorApiV2(result);
          }
          const { usage } = result.data.report;
          let fileTranscodingMinutes = 0;
          for (let i = 0; i < usage.length; i++) {
            if (usage[i].type === 'FileTranscoder:TranscodingMinutes') {
              fileTranscodingMinutes = usage[i].quantity;
              break;
            }
          }
          return commit('setFileTranscodingMinutes', fileTranscodingMinutes);
        })
        .catch((error) => Promise.reject(error));
    },
  },
};
